import { render } from "./NotificationPopup.vue?vue&type=template&id=1db533cc&scoped=true&ts=true"
import script from "./NotificationPopup.vue?vue&type=script&lang=ts"
export * from "./NotificationPopup.vue?vue&type=script&lang=ts"

import "./NotificationPopup.vue?vue&type=style&index=0&id=1db533cc&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db533cc"]])

export default __exports__